define('views/modules/calendar/personal-data/manager/personal-data-manager-panel',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // Views
    'views/parts/panel/base-panel',
    'views/modules/calendar/personal-data/manager/personal-data-manager-content',
    'views/modules/calendar/personal-data/manager/edit/personal-data-edit-panel'
], function(
    // Libs
    _, Backbone, Mustache, U,
    // views
    VBasePanel,
    VPersonalDataManagerContent,
    VPersonalDataEditPanel
) {

    var VPersonalDataManagerPanel = VBasePanel.extend({
        header: {
            title: "calendar:Personal data",
            subtitle: "calendar:Adding/Modify a personal data",
        },
        tabs: [{ id: 'manage', title: 'Manage', active: true }],
        content: {
            manage: VPersonalDataManagerContent
        },
        defaultView: 'manage',
        initialize: function(opt) {
            opt = opt || {};
            var manage = this.getView('manage', { model: this.model });
        },

    });

    return VPersonalDataManagerPanel;
});

